<template>
  <!--
      	作者：gmshop
      	时间：2019-06-04
      	描述：插件中心-分销-分销设置-结算
      -->
  <div class="mt30">

    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">

      <el-form-item label="提现方式">
        <el-checkbox-group v-model="form.pay_type">
          <el-checkbox v-for="(item,index) in list" :label="item.id" :key="index">{{item.name}}</el-checkbox>
        </el-checkbox-group>
        <div class="tips">注：如使用微信支付，则需申请微信支付企业付款到零钱功能</div>
      </el-form-item>
      <el-form-item label="提现到返利手续费">
        <div>
          <el-radio v-model="form.widthdraw_balance_fee" label="0">不收取</el-radio>
          <el-radio v-model="form.widthdraw_balance_fee" label="1">收取</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="提现到返利免审核">
        <div>
          <el-radio v-model="form.widthdraw_balance_auto" label="0">关闭</el-radio>
          <el-radio v-model="form.widthdraw_balance_auto" label="1">开启</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="提现到微信免审核">
        <div>
          <el-radio v-model="form.widthdraw_wechat_auto" label="0">关闭</el-radio>
          <el-radio v-model="form.widthdraw_wechat_auto" label="1">开启</el-radio>
        </div>
      </el-form-item>
      <el-form-item v-if="form.widthdraw_wechat_auto==1" label="微信提现自动免审核金额" prop="wechat_pay_auto_money" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.wechat_pay_auto_money" type="number" class="max-w460"></el-input>
        <div class="tips">
          <p>设置后，提现到微信的金额小于设定值系统会自动打款</p>
        </div>
      </el-form-item>
      <el-form-item label="每月提现次数" prop="month_cash_times" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.month_cash_times" type="number" class="max-w460"></el-input>
        <div class="gray9">设置后每月最多提现n次，为0 不限制</div>
      </el-form-item>
      <el-form-item label="最低提现额度" prop="min_money" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.min_money" type="number" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="提现手续费" prop="charge_fee" :rules="[{required: true,message: ' '}]">
        <el-input placeholder="请输入内容" type="number" min="0"  v-model="form.charge_fee" class="max-w460">
          <template slot="append">%</template>
        </el-input>
      </el-form-item>
      <el-form-item label="单笔固定手续费" prop="widthdraw_fee" :rules="[{required: true,message: ' '}]">
        <el-input placeholder="请输入内容" type="number" min="0"  v-model="form.widthdraw_fee" class="max-w460">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="佣金结算类型" prop="settle_type" :rules="[{required: true,message: ' '}]">
          <el-radio v-model="form.settle_type" label="0">订单完成</el-radio>
          <el-radio v-model="form.settle_type" label="1">付款后</el-radio>
        <div class="tips">
          <p>选择订单完成，佣金会在订单完成后制定时间发放，付款后 表示订单付款后可结算佣金，请注意选择合适方式</p>
        </div>
      </el-form-item>
      <el-form-item label="佣金结算天数" prop="settle_days" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.settle_days" type="number" class="max-w460"></el-input>
        <div class="tips">
          <p>当订单完成n天后，该订单的分销佣金才会结算到分销商返利，如果设置为0天 则订单完成时就结算</p>
          <p class="red">注：建议佣金结算天数大于允许发起售后申请天数，如果用户申请退款退货 则不结算佣金</p>
        </div>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  import PlusApi from '@/api/plus.js';

  export default {
    data() {
      return {
        /*form表单数据*/
        form: {
          pay_type: [
            10
          ],
          widthdraw_balance_fee:0,
          widthdraw_balance_auto:0,
          widthdraw_wechat_auto:0,
          month_cash_times:'0'
        },
        list: [],
        selectlist: [
          10
        ],
        loading: false,
      };
    },
    props: {
      settingData: Object
    },
    created() {

      this.form=this.settingData.data.settlement.values;

      this.list = this.settingData.pay_type;

    },

    methods: {

      /*提交表单*/
      onSubmit() {
        let self = this;
        let params = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            PlusApi.settlement({
                form: params
              }, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，设置成功',
                  type: 'success'
                });

              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
      },

    }

  };
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/plus/agent/setting/part/Settlement.vue